var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","fill-width":""}},[_c('v-row',{staticClass:"ma-9"},[_c('img',{attrs:{"height":"670px","src":require("@/assets/img.jpg")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }